import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

interface StatusCategory {
  id: number;
  name: string;
  displayName: string;
  description: string;
  sortOrder: number;
}

interface RegisterOptionsOptions {
  data: {
    categories: StatusCategory[];
  };
}

export const useStatusCategories = () => {
  return useQuery<RegisterOptionsOptions>(
    ['status-categories'],
    async () => {
      const response = await api.get('/bill-status-categories');
      return response.data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      retry: 2,
    }
  );
};
